export default "__VITE_ASSET__FK67RGyW__"